import _ from "lodash"
import axios from "axios"
import Types from "../actionTypes"

const api = "https://gb335api.herokuapp.com/getStatus"
const regNoRegexp = new RegExp("^[a-zA-Z0-9]{6}")

export const updateContentHeight = (height) => {
	return {
		type: Types.UPDATE_CONTENT_HEIGHT,
		payload: height,
	}
}

// 從 local storage 讀取完整的資料
export const loadData = () => {
	return (dispatch) => {
		if (localStorage) {
			const data = localStorage.getItem("data")
			if (data && data !== "undefined") {
				// 存入 state
				dispatch({
					type: Types.UPDATE_DATA,
					payload: JSON.parse(data),
				})
			}
		} else {
			// 警告不支援 local storage
			console.log("localStorage not support")
		}
	}
}

// 切換 Tab 時，登記目前的 Tab
export const tabChange = (regNo) => {
	return {
		type: Types.UPDATE_CURRENT_REGNO,
		payload: regNo,
	}
}

// 顯示新增 S/O 的 Modal
export const showSoModal = () => {
	return { type: Types.SHOW_SO_MODAL }
}

export const showSoEditModal = () => {
	return (dispatch, getState) => {
		const currentTabRegNo = getState().getIn(["main", "currentTabRegNo"])
		const soData = getState().getIn(["main", "data", currentTabRegNo]).toJS()
		const soNos = _.map(soData, "soNo")

		dispatch({
			type: Types.SHOW_SO_EDIT_MODAL,
			payload: {
				regNo: currentTabRegNo,
				soNos: soNos.join("\n"),
			},
		})
	}
}

// 隱藏新增 S/O 的 Modal
export const hideSoModal = () => {
	return { type: Types.HIDE_SO_MODAL }
}

// 顯示貨櫃單號 Modal
export const showContModal = (contList) => {
	return {
		type: Types.SHOW_CONT_MODAL,
		payload: contList,
	}
}

// 隱藏貨櫃單號 Modal
export const hideContModal = () => {
	return { type: Types.HIDE_CONT_MODAL }
}


// 更新 regNo Input
export const updateRegNoInput = (text) => {
	return {
		type: Types.UPDATE_REG_NO_INPUT,
		payload: text,
	}
}

// 更新 regNo Input
export const updateSoNoTextArea = (text) => {
	return {
		type: Types.UPDATE_SO_NO_TEXTAREA,
		payload: text,
	}
}

// 新增 S/O
export const addSoData = () => {
	return (dispatch, getState) => {
		dispatch({ type: Types.START_SO_MODAL_LOADING })
		const { regNoInputValue, soNoTextAreaValue, data } = getState().get("main").toJS()
		if (!regNoRegexp.test(regNoInputValue)) {
			dispatch({
				type: Types.UPDATE_SO_MODAL_MESSAGE,
				payload: "海關通關號碼格式錯誤",
			})
			return
		}

		if (!soNoTextAreaValue) {
			dispatch({
				type: Types.UPDATE_SO_MODAL_MESSAGE,
				payload: "裝貨單號碼碼格式錯誤",
			})
			return
		}

		// 抓出可以用的 so
		const soNoArray = []
		_.each(soNoTextAreaValue.split("\n"), (line) => {
			if (line && typeof line === "string" && line.trim().length === 4) {
				soNoArray.push(line.trim())
			}
		})

		if (soNoArray.length < 1) {
			dispatch({
				type: Types.UPDATE_SO_MODAL_MESSAGE,
				payload: "裝貨單號碼碼格式錯誤",
			})
			return
		}

		const newData = {}
		newData[regNoInputValue] = _.map(soNoArray, (soNo) => {
			return {
				soNo,
				status: null,
				relDate: null,
				contList: [],
			}
		})

		// 合併新舊 data
		const mergeData = _.merge(data, newData)
		dispatch({
			type: Types.UPDATE_DATA,
			payload: mergeData,
		})

		// 存入 localStorage
		saveData(mergeData)

		// 關閉 modal 結束
		dispatch({ type: Types.HIDE_SO_MODAL })
	}
}

// 編輯 S/O
export const editSoData = () => {
	return (dispatch, getState) => {
		dispatch({ type: Types.START_SO_MODAL_LOADING })
		let { regNoInputValue, soNoTextAreaValue, data } = getState().get("main").toJS()
		if (!regNoRegexp.test(regNoInputValue)) {
			dispatch({
				type: Types.UPDATE_SO_MODAL_MESSAGE,
				payload: "海關通關號碼格式錯誤",
			})
			return
		}

		if (!soNoTextAreaValue) {
			dispatch({
				type: Types.UPDATE_SO_MODAL_MESSAGE,
				payload: "裝貨單號碼碼格式錯誤",
			})
			return
		}

		// 抓出可以用的 so
		const soNoArray = []
		_.each(soNoTextAreaValue.split("\n"), (line) => {
			if (line && typeof line === "string" && line.trim().length === 4) {
				soNoArray.push(line.trim())
			}
		})

		if (soNoArray.length < 1) {
			dispatch({
				type: Types.UPDATE_SO_MODAL_MESSAGE,
				payload: "裝貨單號碼碼格式錯誤",
			})
			return
		}

		// 刪除拿掉的資料
		data[regNoInputValue] = _.filter(data[regNoInputValue], (soData) => {
			return soNoArray.includes(soData.soNo)
		})

		// 加入新增的資料
		_.each(soNoArray, (soNo) => {
			const index = _.findIndex(data[regNoInputValue], (soData) => {
				return soData.soNo === soNo
			})

			// 找不到，要新增
			if (index < 0) {
				data[regNoInputValue].push({
					soNo,
					status: null,
					relDate: null,
					contList: [],
				})
			}
		})

		// 更新 data
		dispatch({
			type: Types.UPDATE_DATA,
			payload: data,
		})

		// 存入 localStorage
		saveData(data)

		// 關閉 modal 結束
		dispatch({ type: Types.HIDE_SO_MODAL })
	}
}

// 查詢 S/O 的狀態
export const querySOStatus = () => {
	return (dispatch, getState) => {
		dispatch({ type: Types.START_QUERY_LOADING })
		const { data } = getState().get("main").toJS()

		if (_.keys(data).length > 0) {
			const promises = []
			_.each(data, (soDataArray, regNo) => {
				promises.push(requestRegState(regNo, soDataArray, dispatch))
			})
			Promise.all(promises)
				.then(() => {
					// 結束 儲存結果
					saveData(getState().getIn(["main", "data"]).toJS())
					dispatch({ type: Types.STOP_QUERY_LOADING })
				})
				.catch((error) => {
					console.log("error", error.message)
					dispatch({ type: Types.STOP_QUERY_LOADING })
				})
		} else {
			// 沒資料
			dispatch({ type: Types.STOP_QUERY_LOADING })
		}
	}
}

// 清除已放行 S/O
export const cleanSoData = () => {
	return (dispatch, getState) => {
		const { data } = getState().get("main").toJS()
		_.each(data, (soDataArray, regNo) => {
			const newArray = []
			_.each(soDataArray, (soData) => {
				if (soData.status !== "Done") {
					newArray.push(soData)
				}
			})
			if (newArray.length === 0) {
				// 刪除 reg
				dispatch({
					type: Types.REMOVE_REG,
					payload: regNo,
				})
			} else {
				// 更新 reg
				dispatch({
					type: Types.UPDATE_REG_DATA,
					payload: {
						regNo,
						data: newArray,
					},
				})
			}
		})
		// 儲存資料
		saveData(getState().getIn(["main", "data"]).toJS())
	}
}

export const deleteSoData = (regNo, soNo) => {
	return (dispatch, getState) => {
		let { data } = getState().get("main").toJS()
		// 刪除指定 soNo
		data[regNo] = _.remove(data[regNo], (soData) => {
			return soData.soNo !== soNo
		})

		// 清除沒有資料的海關通關號碼
		if (data[regNo].length === 0) {
			delete data[regNo]
		}

		dispatch({
			type: Types.UPDATE_DATA,
			payload: data,
		})

		// 存入 localStorage
		saveData(data)
	}
}

export const deleteRegNo = () => {
	return (dispatch, getState) => {
		const currentTabRegNo = getState().getIn(["main", "currentTabRegNo"])
		const data = getState().getIn(["main", "data"]).toJS()
		delete data[currentTabRegNo]

		// 更新到 store
		dispatch({
			type: Types.UPDATE_DATA,
			payload: data,
		})

		// 存入 localStorage
		saveData(data)

	}
}

function requestRegState(regNo, soDataArray, dispatch) {
	return new Promise((resolve, reject) => {
		const promises = []
		_.each(soDataArray, (soData) => {
			promises.push(axios({
				method: "post",
				url: api,
				data: {
					regNo,
					soNo: soData.soNo,
				},
			}))
		})

		Promise.all(promises)
			.then((results) => {
				_.each(results, (result, index) => {
					if (result.data) {
						soDataArray[index].status = result.data.status
						soDataArray[index].relDate = result.data.relDate
						soDataArray[index].contList = result.data.contList
					}
				})
				dispatch({
					type: Types.UPDATE_REG_DATA,
					payload: {
						regNo,
						data: soDataArray,
					},
				})
				resolve()
			})
			.catch((error) => {
				reject(error)
			})
	})
}

function saveData(data) {
	// 存入 localStorage
	if (localStorage) {
		localStorage.setItem("data", JSON.stringify(data))
	} else {
		// 警告不支援 local storage
		console.log("localStorage not support")
	}
}



// WEBPACK FOOTER //
// ./src/redux/main/action.js